<div class="qa-translation-overlay" *ngIf="visible" (click)="onBackdropClick($event)">
  <div class="card qa-translation-dialog" role="dialog" aria-modal="true">
    <div class="card-header">
      <span><i class="fa fa-language" aria-hidden="true"></i> {{_(KEYS.EDITOR.AUTOMATIC_QUESTIONNAIRE_TRANSLATION)}}</span>
      <button type="button" class="close" (click)="hide()" [disabled]="isTranslating" [attr.aria-label]="_(KEYS.EDITOR.CLOSE)">
        <i class="fa fa-close" aria-hidden="true"></i>
      </button>
    </div>

    <div class="card-body">
      <div *ngIf="canUseDeepl || canUseOpenai" class="qa-translation-section">
        <div class="qa-translation-label">{{_(KEYS.EDITOR.TRANSLATION_SERVICE)}}</div>
        <div class="qa-translation-segments" role="radiogroup" [attr.aria-label]="_(KEYS.EDITOR.TRANSLATION_SERVICE)">
          <button *ngIf="canUseDeepl" type="button" role="radio" [attr.aria-checked]="backend === 'deepl'"
                  [class.active]="backend === 'deepl'" [disabled]="isTranslating" (click)="onBackendChange('deepl')">
            <i class="fa fa-language" aria-hidden="true"></i> DeepL
          </button>
          <button *ngIf="canUseOpenai" type="button" role="radio" [attr.aria-checked]="backend === 'openai'"
                  [class.active]="backend === 'openai'" [disabled]="isTranslating" (click)="onBackendChange('openai')">
            <i class="fa fa-lightbulb-o" aria-hidden="true"></i> OpenAI
          </button>
        </div>
      </div>

      <div class="qa-translation-section">
        <div class="qa-translation-label">{{_(KEYS.EDITOR.SOURCE_LANGUAGE)}}</div>
        <div class="qa-translation-source">
          <span class="flag-icon flag-icon-{{getFlagCode(anchorLocale)}}"></span>
          {{translateLanguage(languages[anchorLocale])}}
        </div>
      </div>

      <div class="qa-translation-section qa-translation-targets">
        <div class="qa-translation-label">
          {{_(KEYS.EDITOR.TARGET_LANGUAGES)}}
          <span class="qa-translation-count">{{selectedTargetCount}}</span>
          <button type="button" class="qa-translation-select-all" (click)="toggleAllTargets()" [disabled]="isTranslating">
            {{allTargetsSelected ? _(KEYS.EDITOR.DESELECT_ALL) : _(KEYS.EDITOR.SELECT_ALL)}}
          </button>
        </div>
        <div class="qa-translation-languages">
          <label *ngFor="let code of targetLocales" class="qa-translation-language"
                 [class.selected]="selectedLanguages.includes(code)" [class.disabled]="isTranslating">
            <input type="checkbox" [checked]="selectedLanguages.includes(code)" (change)="toggleLanguage(code)" [disabled]="isTranslating"/>
            <span class="flag-icon flag-icon-{{getFlagCode(code)}}"></span>
            <span class="qa-translation-name">{{translateLanguage(languages[code])}}</span>
          </label>
        </div>
      </div>

      <div *ngIf="isTranslating || translationProgress === 100" class="qa-translation-progress" role="progressbar"
           [attr.aria-valuenow]="translationProgress" aria-valuemin="0" aria-valuemax="100">
        <div class="qa-translation-progress-track"><div [style.width.%]="translationProgress"></div></div>
        <span>{{translationProgress}} %</span>
      </div>
    </div>

    <div class="card-footer">
      <span *ngIf="charsToTranslate" class="qa-translation-estimate">
        {{formatNumber(charsToTranslate)}} {{_(KEYS.EDITOR.CHARS)}} · {{_(KEYS.EDITOR.ESTIMATED_COST)}} ~{{formatNumber(estimatePrice, 2)}} €
      </span>
      <button type="button" class="btn btn-outline-secondary" (click)="hide()" [disabled]="isTranslating">{{_(KEYS.EDITOR.CLOSE)}}</button>
      <button type="button" class="btn btn-success" (click)="translateQuestionnaire()"
              [disabled]="isTranslating || selectedLanguages.length < 2 || (!canUseDeepl && !canUseOpenai)">
        <i class="fa" [ngClass]="isTranslating ? 'fa-circle-o-notch fa-spin' : 'fa-language'" aria-hidden="true"></i>
        {{_(KEYS.EDITOR.TRANSLATE_QUESTIONNAIRE)}}
      </button>
    </div>
  </div>
</div>
